import PropTypes from 'prop-types';
import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

import { isInstructor } from '../../../../../utils/user';
import noPostStudent1Image from '../../../../../../static/images/no-item/nopostyet1.png';
import noPostStudent2Image from '../../../../../../static/images/no-item/nopostyet2.png';
import noPostInstructorImage from '../../../../../../static/images/no-item/nopostyet3.png';

import style from './style';
import * as TEXT from '../../../../../constants/texts';

let noPostDismissed = false;

class NoPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: !noPostDismissed,
    };

    this.dismiss = this.dismiss.bind(this);
  }

  dismiss() {
    noPostDismissed = true;
    this.setState({ display: false });
  }

  renderCloseIcon() {
    return (
      <div
        tabIndex={0}
        role="button"
        onClick={this.dismiss}
        style={style.dismiss}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            this.dismiss();
          }
        }}
      >
        <CloseIcon />
      </div>
    );
  }

  renderNoPostInstructor() {
    return (
      <div style={style.container}>
        <div style={style.titleRow}>
          <div style={style.title}>
            <div>
              <img style={style.image} src={noPostInstructorImage} alt="" />
            </div>
            <span style={style.titleText}>
              <span>There are no posts yet. </span>
              <span style={style.titleEmphasised}>Welcome</span>
              <span> your students!</span>
            </span>
          </div>
          {this.renderCloseIcon()}
        </div>
        <div style={style.description}>{TEXT.FEED_NOPOSTS}</div>
      </div>
    );
  }

  renderNoPostStudent() {
    return (
      <div style={style.container}>
        <div style={style.titleRow}>
          <div style={style.title}>There are no posts yet!</div>
          {this.renderCloseIcon()}
        </div>
        <div style={style.description}>
          <div style={style.descriptionSplitContainer}>
            <div style={style.descriptionTitle}>
              <img
                style={style.descriptionTitleImage}
                src={noPostStudent1Image}
                alt=""
              />
              <span>ASK A QUESTION</span>
            </div>
            <div style={style.descriptionText}>
              Get your unanswered questions about class content, exams and
              exercises resolved with the help of your educator and classmates.
            </div>
          </div>
          <div style={style.descriptionSplitContainer}>
            <div style={style.descriptionTitle}>
              <img
                style={style.descriptionTitleImage}
                src={noPostStudent2Image}
                alt=""
              />
              <span>SHARE WITH YOUR CLASS</span>
            </div>
            <div style={style.descriptionText}>
              Contribute to the community by sharing articles, videos,
              anecdotes, etc. with your class.
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { display } = this.state;
    if (!display) {
      return null;
    }

    const { userId } = this.props;
    const userIsInstructor = isInstructor(userId);
    return userIsInstructor
      ? this.renderNoPostInstructor()
      : this.renderNoPostStudent();
  }
}

NoPost.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default NoPost;
